angular
	.module 'App.Repository'

.factory 'TenderTypeSalesRepository', ['BaseRepository', (BaseRepository) ->
	class TenderTypeSalesRepository extends BaseRepository
		@resource = '/reports/tender_type_sales'
		@isRestricted = true

	return new TenderTypeSalesRepository
]
